import { useState, useEffect, useRef } from 'react';
import { getReportTaskStatus } from '../api/studyListApi';

const POLL_INTERVAL_MS = 2000;

const downloadFile = (url) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const usePollReport = ({ onSuccess, onError } = {}) => {
  const [taskId, setTaskId] = useState(null);
  const [status, setStatus] = useState(null); // null | 'polling' | 'complete' | 'error'
  const intervalRef = useRef(null);

  const startPolling = (id) => {
    setTaskId(id);
    setStatus('polling');
  };

  useEffect(() => {
    if (!taskId) return;

    intervalRef.current = setInterval(async () => {
      try {
        const data = await getReportTaskStatus(taskId);
        if (data.complete) {
          clearInterval(intervalRef.current);
          setTaskId(null);
          if (data.success) {
            setStatus('complete');
            downloadFile(data.result);
            onSuccess?.(data.result);
          } else {
            setStatus('error');
            onError?.();
          }
        }
      } catch {
        clearInterval(intervalRef.current);
        setTaskId(null);
        setStatus('error');
        onError?.();
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(intervalRef.current);
  }, [taskId]);

  return { startPolling, status };
};

export default usePollReport;
